import type React from 'react';

import { MembershipBottomBanner as Layout } from './component';
import {
	MembershipBottomBannerDataProvider,
	MembershipBottomBannerStateContextProvider,
	useIsEligible,
} from './context';
import type { EntryProps } from './shared/types';

export const MembershipBottomBanner: React.FC<EntryProps> = ({ data, ...layoutProps }) => {
	const isEligible = useIsEligible();

	if (!isEligible) return null;

	return (
		<MembershipBottomBannerDataProvider data={data}>
			<MembershipBottomBannerStateContextProvider>
				<Layout {...layoutProps} />
			</MembershipBottomBannerStateContextProvider>
		</MembershipBottomBannerDataProvider>
	);
};
